module.exports = __webpack_public_path__ + "img/ma.d0e6efc0.png";